/**
 * Tracks the last `/peek-reference` value so we can:
 * - Apply new peek results only while the field still matches that preview (user edits block overwrites).
 * - Omit `ref` on create when unchanged so the backend runs allocateReference (unique seq).
 *
 * Uniqueness is always enforced on the server; the frontend cannot allocate globally unique seq safely.
 */
function createPeekSnapshot() {
  let lastPeeked = '';

  return {
    reset() {
      lastPeeked = '';
    },
    getLastPeeked() {
      return lastPeeked;
    },
    setFromPeek(ref: string) {
      lastPeeked = (ref ?? '').trim();
    },
    /** Allow programmatic peek to replace `ref` only if user has not diverged from the last preview. */
    shouldApplyPeekToForm(currentRef: string) {
      const c = (currentRef ?? '').trim();
      return c === '' || c === lastPeeked;
    },
    /** When true, create payload should omit `ref` so the server allocates the next sequence. */
    shouldOmitRefForServerAllocation(currentRef: string) {
      const c = (currentRef ?? '').trim();
      return c === '' || c === lastPeeked;
    },
  };
}

export const supplyCaseRefPeekSnapshot = createPeekSnapshot();
export const supplyRequisitionRefPeekSnapshot = createPeekSnapshot();
